import { render, staticRenderFns } from "./portArchive.vue?vue&type=template&id=6978ba5a"
import script from "./portArchive.vue?vue&type=script&lang=js"
export * from "./portArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports